import "@/components/FullPageEditor/styles/richEditor.css";
import "katex/dist/katex.min.css";

import { themeColors } from "@/utils/themeColors";
import clsx from "clsx";
import { CSSProperties } from "react";
import ReactHtmlParser, { convertNodeToElement } from "react-html-parser";
import { renderLatexToString, swapLineHeightAttributePreProcessor } from "./preprocessor";
import { isHtml } from "@knowt/editor/helpers/isHtml";

type HtmlTextProps = {
    text?: string | null;
    style?: CSSProperties;
    onClick?: () => void;
    className?: string;
};

const transform = (node: any, _index: number) => {
    if (node.name === "svg") {
        const { viewbox, preserveaspectratio, ...rest } = node.attribs;
        return (
            // biome-ignore lint: a11y/noSvgWithoutTitle
            <svg {...rest} viewBox={viewbox} preserveAspectRatio={preserveaspectratio} style={{ width: "100%" }}>
                {node.children.map((child, index) => {
                    return convertNodeToElement(child, index, transform);
                })}
            </svg>
        );
    }
};

const HtmlText = ({ text, style, onClick, className }: HtmlTextProps) => {
    const processedText = text ? (!isHtml(text) ? text?.replaceAll("\n", "<br />") : text) : "";

    const latexParsed = renderLatexToString(processedText);

    const reactParsed = ReactHtmlParser(latexParsed, {
        preprocessNodes: nodes => {
            if (style?.lineHeight) {
                swapLineHeightAttributePreProcessor(nodes, style.lineHeight);
            }
            return nodes;
        },
        transform,
    });

    const content = reactParsed || latexParsed || text;

    return (
        <div
            className={clsx("ProseMirror", className)}
            style={{
                background: "transparent",
                color: themeColors.neutralBlack,
                fontFamily: "var(--knowt-font-name)",
                height: "fit-content",
                lineHeight: "24px",
                ...style,
            }}
            onClick={onClick}>
            {content}
        </div>
    );
};

export default HtmlText;
